import { Record } from 'immutable';
const TranslateTemplateModalRecord = Record({
  modalOpen: false
});
export default TranslateTemplateModalRecord;